<permission-checker [roles]="roles" (contentInit)="initContent()">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
      <mat-toolbar-row class="toolbar-row">
        <h1>
          <ng-container *ngIf="contest;else contestLoading">{{contest.name}}:
            &nbsp;
            <ng-container *ngIf="regions && regionId">{{regions.get(regionId)}}</ng-container>
          </ng-container>
          <ng-template #contestLoading>
            <mat-spinner color="primary" diameter="40"></mat-spinner>
          </ng-template>
        </h1>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="content page">
      <div *ngIf="!inProgress && examStats && examStats.length > 0 && schools && schools.length > 0;else noStatsInfo">
        <mat-card *ngFor="let school of schools" class="school-card">
          <mat-card-header>
            <mat-card-title>{{school.short_name || school.name}}</mat-card-title>
            <mat-card-subtitle *ngIf="school.short_name">{{school.name}}</mat-card-subtitle>

            <mat-card-subtitle class="card-subtitle">
                <span class="mat-small text-disabled-color sub-header-section-header"
                      i18n="School details|School address@@school-details-address-sub-title">
                  School address:
                </span>
              <span class="mat-body-2">{{school.address}}, &thinsp;{{school.region_name}}</span>
            </mat-card-subtitle>
            <mat-card-subtitle *ngIf="school.phone" class="card-subtitle">
                <span class="mat-small text-disabled-color sub-header-section-header"
                      i18n="School details|School phone number@@school-details-phone-number-sub-title">
                  School phone number:
                </span>
              <span class="mat-body-2">{{school.phone}}</span>
            </mat-card-subtitle>
            <mat-card-subtitle *ngIf="school.email" class="card-subtitle">
                <span class="mat-small text-disabled-color sub-header-section-header"
                      i18n="School email|School address@@school-details-email-sub-title">
                  School email:
                </span>
              <span class="mat-body-2">{{school.email}}</span>
            </mat-card-subtitle>
            <mat-card-subtitle class="card-subtitle">
                <span class="mat-small text-disabled-color sub-header-section-header"
                      i18n="School details|School contact person@@school-details-contact-person-sub-title">
                  School contact:
                </span>
              <span *ngIf="school.contact_name" class="mat-body-2">{{school.contact_name}}</span>
              <span *ngIf="!school.contact_name" class="mat-body-2">&#8211;</span>
            </mat-card-subtitle>
          </mat-card-header>

          <mat-card-content>
            <exam-results-table class="full-width"
                                [showLocation]="false"
                                [showEmail]="true"
                                [showGrade]="true"
                                [mobileView]="mobileView"
                                [examStats]="schoolStats.get(school.id) || []"
                                [regions]="regions"
                                [showAnswerSheets]="false"></exam-results-table>

            <grade-results-table class="full-width grade-results"
                                 [stats]="[schoolGradeStats.get(school.id) || {excellent_count: 0, good_count: 0, average_count: 0}]"></grade-results-table>
          </mat-card-content>
        </mat-card>
      </div>

      <ng-template #noStatsInfo>
        <app-no-content *ngIf="!inProgress && contest"
                        [compact]="true"
                        title="No statistical data available at the moment"
                        i18n-title="Stats|User exam card stats missing title@@stats-user-exam-card-stats-missing-title"
                        details="Stats will be populated after students participate in the contest"
                        i18n-details="Stats|Users exam stats missing details@@stats-users-exam-stats-missing-details"></app-no-content>
      </ng-template>

      <mat-spinner *ngIf="inProgress" color="primary" diameter="30" class="center progress"></mat-spinner>
    </div>
  </div>
</permission-checker>
